import api from "../../infra/api";

class FileIni {
    async Inserir (dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/FileIni/GravaValoresFileIni",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async Recuperar(dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/FileIni/BuscaValoresFileIni",
            data: JSON.stringify(dto)
        });

        return response.data;
    }
}

export default new FileIni;